module.exports = "<div class=\"container-fluid\" style=\"background-color: #ef3b2b\">\r\n<img style=\"max-height:150px;margin-left:100px; \" src=\"assets/images/footer-logo.png\" alt=\"\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/footer/footer.component.html
// module id = ../../../../../src/app/footer/footer.component.html
// module chunks = main